export default __webpack_public_path__ + "static/media/google-photos.aeb4c846.svg";